<template>
	<div class="step-0">
		<h1>Los geht's!</h1>
		<div class="step-0--intro">
			<div class="step-0--intro-title">Welchen Job möchtest du besetzen,<br/> welche Skills werden dafür benötigt?
			</div>
			<div class="step-0--intro-text">
				skilldoo bietet dir auf der nächsten Seite ein ganz einfaches Klick-System:<br/>
				Wähle einfach und schnell aus, was dein Best-Match wäre!
			</div>
			<Button text="Weiter gehts..." icon="checkmark" @click="$emit('continue')"/>
		</div>
	</div>
</template>

<script>
import Button from "@/vue/common/Button.vue";

export default {

	components: {
		Button,
	},
}
</script>
